module.exports = "<ng-content></ng-content>\n<td *ngIf=\"state\" class=\"spinner-block-parent\">\n    <div class=\"spinner-block\">\n      <ui-spinner [show]=\"state\"></ui-spinner>\n    </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-table-spinner/ui-spinner.html
// module id = 1067
// module chunks = 3